// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3YOVm","newExpiryDate":"styles_newExpiryDate__22oE3","footer":"styles_footer__2sCRG"};